module.exports = __webpack_public_path__ + "img/ar-view_blur.8cce0b1.jpg";